import { browser } from '$app/environment';
import {
    PUBLIC_ENABLE_CHECKOUT,
    PUBLIC_MAINTENANCE,
    PUBLIC_ORIGIN,
    PUBLIC_PRODUCTION
} from '$env/static/public';
import { get, readable, writable } from 'svelte/store';

export const site_origin = PUBLIC_ORIGIN;

export const isProd = PUBLIC_PRODUCTION === 'true';

export const isCheckoutEnabled = PUBLIC_ENABLE_CHECKOUT === 'true';

export const isIOS = browser
    ? navigator?.userAgent.match(/(iPad|iPhone|iPod)/g)
    : false;
export const isMac = browser ? navigator.userAgent.match(/(Mac)/g) : false;

export const under_maintenance = PUBLIC_MAINTENANCE === 'true';

export const cookie_consent_asked = writable(false);
export const cookie_consent_preferences = writable(false);
export const cookie_consent_marketing = writable(false);
export const cookie_consent_statistics = writable(false);

if (browser) {
    try {
        cookie_consent_asked.set(
            localStorage.getItem('cookie_consent_asked') === 'true' ||
                document.cookie.includes('cookie_consent_asked=true')
        );

        cookie_consent_preferences.set(
            localStorage.getItem('cookie_consent_preferences') === 'true' ||
                document.cookie.includes('cookie_consent_preferences=true')
        );

        cookie_consent_marketing.set(
            localStorage.getItem('cookie_consent_marketing') === 'true' ||
                document.cookie.includes('cookie_consent_marketing=true')
        );

        cookie_consent_statistics.set(
            localStorage.getItem('cookie_consent_statistics') === 'true' ||
                document.cookie.includes('cookie_consent_statistics=true')
        );

        cookie_consent_asked.subscribe((value) => {
            localStorage.setItem('cookie_consent_asked', `${value}`);
        });
        
        cookie_consent_preferences.subscribe((value) => {
            let asked = get(cookie_consent_asked);
            if (!asked) return;
            localStorage.setItem('cookie_consent_preferences', `${value}`);
        });

        cookie_consent_marketing.subscribe((value) => {
            let asked = get(cookie_consent_asked);
            if (!asked) return;
            localStorage.setItem('cookie_consent_marketing', `${value}`);
        });

        cookie_consent_statistics.subscribe((value) => {
            let asked = get(cookie_consent_asked);
            if (!asked) return;
            localStorage.setItem('cookie_consent_statistics', `${value}`);
        });
    } catch (error) {
        console.error('Error accessing cookie or local storage', error);
    }
}

/**
 * @type {import('svelte/store').Writable<DiscountData>}
 */
export const discount_data = writable({
    active: false
});

/**
 * True once the root layout has looked up the visitor's promo code (?d_id=,
 * saved code, site-wide discount), so a checkout opened on page load
 * (BuyPage) can wait for it instead of opening without the discount.
 * @type {import('svelte/store').Writable<boolean>}
 */
export const discount_checked = writable(false);

/** @type {import('svelte/store').Writable<Promise<string[]>>} */
export const purchased_courses = writable(Promise.resolve([]));

export const completed_courses = writable(Promise.resolve([]));
